export default async function ({ store, redirect, route }) {
  if (
    store.getters['user/user'] &&
    store.getters['user/user'].email &&
    store.getters['user/user'].email === 'anonymous@pedalsure.com'
  ) {
    return redirect(`/login?nextUrl=${route.path}`)
  }

  if (!store.getters['user/isAuthenticated']) {
    await store.dispatch('user/logout')
    return redirect(`/login?nextUrl=${route.path}`)
  }
}
